import CrudManager from "@/components/admin/CrudManager";

export default function AdminTeam() {
  return (
    <CrudManager
      title="Team"
      subtitle="Beheer bestuursleden"
      listEndpoint="/team"
      adminEndpoint="/admin/team"
      fields={[
        { name: "name", label: "Naam", required: true },
        { name: "role", label: "Functie", required: true },
        { name: "image_url", label: "Foto", type: "image" },
        { name: "bio", label: "Bio", type: "textarea" },
        { name: "email", label: "E-mail" },
        { name: "linkedin", label: "LinkedIn URL" },
        { name: "order", label: "Volgorde", type: "number", default: 0 },
      ]}
      columns={[
        { key: "order", label: "#" },
        { key: "name", label: "Naam" },
        { key: "role", label: "Functie" },
      ]}
    />
  );
}
